var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_freccia_input_periodo",
    "data-name": "icona freccia input periodo",
    transform: "translate(-1005 -39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_feccia_input_periodo",
    "data-name": "icona feccia input periodo",
    d: "M4.1,11.7a1.01,1.01,0,0,0,1.428,0L9.342,7.9A1.01,1.01,0,1,0,7.914,6.467L5.829,8.552V1.01a1.01,1.01,0,0,0-2.02,0V8.552L1.724,6.467A1.01,1.01,0,1,0,.3,7.9Z",
    transform: "translate(1005 49.638) rotate(-90)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_775",
    "data-name": "Rettangolo 775",
    transform: "translate(1005 39)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.559eecf6d75507301f8ed789b84d1cb0.svg";
export { ForwardRef as ReactComponent };